import dayjs from 'dayjs';
import { TruckDeviceLockStatus } from 'app/shared/model/enumerations/truck-device-lock-status.model';

export interface ITruckDeviceStatusHistory {
  id?: number;
  userId?: number | null;
  truckId?: number | null;
  companyId?: number | null;
  deviceId?: number;
  created?: string;
  status?: TruckDeviceLockStatus;
}

export const defaultValue: Readonly<ITruckDeviceStatusHistory> = {};
